<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端 ====================== -->
    <div class="pc-version">
      <div
        class="order-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <!-- 顶部搜索栏（折叠版） -->
        <div class="search-bar">
          <!-- 折叠/展开按钮 -->
          <el-button
            icon="el-icon-arrow-down"
            type="text"
            @click="toggleSearch"
            style="margin-right: 10px"
          >
            {{ searchCollapsed ? "展开搜索" : "收起搜索" }}
          </el-button>

          <!-- 搜索项 -->
          <div
            :style="{
              display: searchCollapsed ? 'none' : 'flex',
              alignItems: 'center',
              gap: '10px',
              flexWrap: 'wrap',
            }"
          >
            <el-input
              v-model="searchParams.user_id"
              placeholder="请输入用户ID"
              clearable
              style="width: 180px"
            ></el-input>
          </div>

          <!-- 搜索/重置/列筛选 -->
          <div style="display: flex; gap: 10px; margin-left: 10px">
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="getOrderList"
            >
              搜索
            </el-button>
            <el-button icon="el-icon-refresh" @click="resetSearch">
              重置
            </el-button>
            <el-popover
              placement="bottom"
              title="显示列筛选"
              trigger="click"
              width="260"
            >
              <el-checkbox-group v-model="checkedColumns">
                <el-checkbox
                  v-for="item in columnOptions"
                  :key="item.prop"
                  :label="item.prop"
                  >{{ item.label }}</el-checkbox
                >
              </el-checkbox-group>
              <div style="text-align: right; margin-top: 8px">
                <el-button size="mini" @click="handleCheckAll">全选</el-button>
                <el-button size="mini" @click="handleClearAll">清空</el-button>
              </div>
              <el-button slot="reference" icon="el-icon-s-tools" type="info"
                >列筛选</el-button
              >
            </el-popover>
          </div>
        </div>

        <el-table
        height="900"
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
          @row-click="handleRowClick"
        >
          <el-table-column
            label="头像"
            width="80"
            align="center"
            v-if="checkedColumns.includes('avatar')"
          >
            <template slot-scope="scope">
              <el-avatar :src="scope.row.avatar" size="40"></el-avatar>
            </template>
          </el-table-column>
          <el-table-column
            label="订单ID"
            prop="id"
            width="110"
            align="center"
            v-if="checkedColumns.includes('id')"
          />
          <el-table-column
            label="用户ID"
            prop="user_id"
            width="110"
            align="center"
            v-if="checkedColumns.includes('user_id')"
          />
          <el-table-column
            label="用户编号"
            prop="user_no"
            min-width="160"
            align="center"
            v-if="checkedColumns.includes('user_no')"
          />
          <el-table-column
            label="用户昵称"
            prop="nickname"
            min-width="140"
            v-if="checkedColumns.includes('nickname')"
          />
          <el-table-column
            label="盲盒图"
            width="90"
            align="center"
            v-if="checkedColumns.includes('box_image')"
          >
            <template slot-scope="scope">
              <el-avatar
                :src="scope.row.box_image"
                size="40"
                shape="square"
              ></el-avatar>
            </template>
          </el-table-column>
          <el-table-column
            label="盲盒ID"
            prop="box_id"
            width="100"
            align="center"
            v-if="checkedColumns.includes('box_id')"
          />
          <el-table-column
            label="盲盒名称"
            prop="box_name"
            min-width="160"
            v-if="checkedColumns.includes('box_name')"
          />
          <el-table-column
            label="盲盒定价"
            prop="box_price"
            width="100"
            align="center"
            v-if="checkedColumns.includes('box_price')"
          />
          <el-table-column
            label="业务类型"
            width="100"
            align="center"
            v-if="checkedColumns.includes('type')"
          >
            <template slot-scope="scope">
              <span
                :style="{
                  color:
                    scope.row.typeDesc == 10
                      ? '#F56C6C'
                      : scope.row.typeDesc == 2
                      ? '#E6A23C'
                      : '#67C23A',
                }"
              >
                {{ scope.row.type }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="购买数量"
            prop="num"
            width="90"
            align="center"
            v-if="checkedColumns.includes('num')"
          />
          <el-table-column
            label="总支付金额"
            prop="total_price"
            width="110"
            align="center"
            v-if="checkedColumns.includes('total_price')"
          />
          <el-table-column
            label="实付金额"
            prop="pay_price"
            width="110"
            align="center"
            v-if="checkedColumns.includes('pay_price')"
          />
          <el-table-column
            label="盲盒钻石支付"
            prop="pay_blind_point"
            width="120"
            align="center"
            v-if="checkedColumns.includes('pay_blind_point')"
          />
          <el-table-column
            label="闯关币支付"
            prop="pay_challenge_point"
            width="120"
            align="center"
            v-if="checkedColumns.includes('pay_challenge_point')"
          />
          <el-table-column
            label="擂台币支付"
            prop="pay_fight_point"
            width="120"
            align="center"
            v-if="checkedColumns.includes('pay_fight_point')"
          />
          <el-table-column
            label="PK币支付"
            prop="pay_pk_point"
            width="100"
            align="center"
            v-if="checkedColumns.includes('pay_pk_point')"
          />
          <el-table-column
            label="支付时间"
            prop="paid_at"
            min-width="170"
            align="center"
            v-if="checkedColumns.includes('paid_at')"
          />
          <el-table-column
            label="操作"
            width="120"
            align="center"
            fixed="right"
            v-if="checkedColumns.includes('action')"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-view"
                style="color: #409eff"
                @click.stop="openDetailDialog(scope.row)"
                >查看明细</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- PC 订单明细弹窗 -->
        <!-- PC 订单明细弹窗 -->
        <el-dialog
          title="订单开出明细"
          :visible.sync="detailVisible"
          width="1200px"
          append-to-body
        >
          <div v-loading="detailLoading">
            <el-table
              :data="detailData"
              border
              size="small"
              style="width: 100%"
            >
              <el-table-column
                label="用户昵称"
                prop="nickname"
                width="90"
                align="center"
              />
              <el-table-column
                label="用户编号"
                prop="user_no"
                width="80"
                align="center"
              />
              <el-table-column
                label="用户ID"
                prop="user_id"
                width="80"
                align="center"
              />
              <el-table-column label="用户头像" width="90" align="center">
                <template slot-scope="scope">
                  <el-avatar
                    :src="scope.row.avatar"
                    size="50"
                    shape="square"
                  ></el-avatar>
                </template>
              </el-table-column>
              <el-table-column label="奖品图" width="90" align="center">
                <template slot-scope="scope">
                  <el-avatar
                    :src="scope.row.box_prize_image"
                    size="50"
                    shape="square"
                  ></el-avatar>
                </template>
              </el-table-column>
              <el-table-column
                label="奖品ID"
                prop="id"
                width="90"
                align="center"
              />
              <el-table-column
                label="盲盒ID"
                prop="box_id"
                width="80"
                align="center"
              />
              <el-table-column
                label="盲盒名称"
                prop="box_name"
                min-width="140"
              />
              <!-- <el-table-column label="商品ID" prop="goods_id" width="90" align="center" /> -->
              <!-- <el-table-column label="分类ID" prop="cate_id" width="80" align="center" /> -->
              <el-table-column
                label="奖品类型"
                prop="prize_type"
                width="90"
                align="center"
              />
              <!-- <el-table-column label="倍率" prop="multiple" width="70" align="center" /> -->
              <el-table-column
                label="奖品等级"
                prop="level_name"
                width="100"
                align="center"
              />
              <!-- <el-table-column label="等级值" prop="box_prize_level" width="80" align="center" /> -->
              <el-table-column
                label="单价"
                prop="price"
                width="90"
                align="center"
              />
              <el-table-column
                label="亏损价"
                prop="loss_price"
                width="90"
                align="center"
              />
              <el-table-column
                label="回收价"
                prop="recovery_price"
                width="90"
                align="center"
              />
              <el-table-column
                label="数量"
                prop="num"
                width="80"
                align="center"
              />
              <!-- <el-table-column label="状态码" prop="status" width="80" align="center" /> -->
              <el-table-column
                label="状态描述"
                prop="status_desc"
                width="100"
                align="center"
              />
              <!-- <el-table-column label="父级ID" prop="parent_id" width="90" align="center" /> -->
              <!-- <el-table-column label="父级是否盲盒" prop="parent_is_box" width="100" align="center" /> -->
              <!-- <el-table-column label="赠送ID" prop="give_id" width="90" align="center" /> -->
              <!-- <el-table-column label="接收赠送ID" prop="to_give_id" width="110" align="center" /> -->
              <!-- <el-table-column label="业务类型" prop="type" width="80" align="center" /> -->
              <el-table-column
                label="开出时间"
                prop="created_at"
                min-width="160"
                align="center"
              />
              <el-table-column
                label="更新时间"
                prop="updated_at"
                min-width="160"
                align="center"
              />
            </el-table>

            <el-pagination
              @current-change="getDetailList"
              :current-page="detailParams.page"
              :page-size="detailParams.page_size"
              layout="prev, pager, next"
              :total="detailTotal"
              style="text-align: center; margin-top: 15px"
            ></el-pagination>
          </div>
          <div slot="footer" style="text-align: right">
            <el-button @click="detailVisible = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- ====================== 移动端 ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-order-container"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <!-- 搜索 -->
        <div class="mobile-search-group">
          <el-button
            type="text"
            icon="el-icon-arrow-down"
            @click="toggleSearch"
            style="width: 100%; text-align: left; padding-left: 0"
          >
            {{ searchCollapsed ? "展开搜索条件 ▼" : "收起搜索条件 ▲" }}
          </el-button>
          <div
            v-if="!searchCollapsed"
            style="display: flex; flex-direction: column; gap: 8px"
          >
            <el-input
              v-model="searchParams.user_id"
              placeholder="用户ID"
              clearable
              size="medium"
            />
          </div>
        </div>
        <div style="display: flex; gap: 8px; margin-bottom: 10px">
          <el-button
            type="primary"
            plain
            round
            @click="getOrderList"
            style="flex: 1"
            >搜索</el-button
          >
          <el-button plain round @click="resetSearch" style="flex: 1"
            >重置</el-button
          >
        </div>

        <!-- 移动端订单卡片列表 -->
        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
            @click="openDetailDialogMobile(item)"
          >
            <div class="card-header">
              <div style="display: flex; align-items: center; gap: 10px">
                <el-avatar :src="item.avatar" size="50"></el-avatar>
                <div class="info">
                  <div class="nickname">{{ item.nickname || "未知用户" }}</div>
                  <div class="uid">
                    订单ID: {{ item.id }} · 用户ID: {{ item.user_id }} ·
                    用户编号: {{ item.user_no }}
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div
                style="
                  display: flex;
                  align-items: center;
                  gap: 8px;
                  margin-bottom: 4px;
                "
              >
                <el-avatar
                  :src="item.box_image"
                  size="36"
                  shape="square"
                ></el-avatar>
                <span
                  >宝箱：{{ item.box_name }}（ID:{{ item.box_id }} 定价¥{{
                    item.box_price
                  }}）</span
                >
              </div>
              <div>
                类型：
                <span
                  :style="{
                    color:
                      item.typeDesc == 10
                        ? '#F56C6C'
                        : item.typeDesc == 2
                        ? '#E6A23C'
                        : '#67C23A',
                  }"
                >
                  {{ item.type }}
                </span>
              </div>
              <div>
                数量：{{ item.num }} | 总支付金额：¥{{ item.total_price }} |
                实付：¥{{ item.pay_price }}
              </div>
              <div>
                盲盒钻石支付：{{ item.pay_blind_point }} | 闯关币：{{
                  item.pay_challenge_point
                }}
              </div>
              <div>
                擂台币：{{ item.pay_fight_point }} | PK币：{{
                  item.pay_pk_point
                }}
              </div>
              <div>支付时间：{{ item.paid_at }}</div>
            </div>
            <div class="card-footer">
              <el-button
                size="mini"
                type="primary"
                round
                @click.stop="openDetailDialogMobile(item)"
                >查看明细</el-button
              >
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            layout="total, prev, pager, next"
            :total="pageInfo.total"
            pager-count="2"
            small
          />
        </div>

        <!-- 移动端详情弹窗（明细卡片） -->
        <el-dialog
          title="订单开出明细"
          :visible.sync="detailVisibleMobile"
          width="95%"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div v-loading="detailLoading">
            <div class="mobile-card-list" style="padding: 0">
              <div
                class="mobile-card"
                v-for="item in detailData"
                :key="item.id"
                style="margin-bottom: 10px"
              >
                <div class="card-header" style="display: flex; gap: 10px; align-items: flex-start;">
          <!-- 用户头像 -->
          <el-avatar
            :src="item.avatar"
            size="60"
            shape="square"
          ></el-avatar>
          <div class="info" style="flex: 1;">
            <div class="nickname">用户昵称：{{ item.nickname || '--' }}</div>
            <div class="uid">用户编号：{{ item.user_no || '--' }}</div>
            <div class="uid">用户ID：{{ item.user_id || '--' }}</div>
          </div>
          <!-- 奖品图片 -->
          <el-avatar
            :src="item.box_prize_image"
            size="60"
            shape="square"
          ></el-avatar>
        </div>
                <div class="card-body">
                  <div>
                    盲盒信息：{{ item.box_name }}（box_id:{{ item.box_id }}）
                  </div>
                  <div>
                    商品ID：{{ item.goods_id }}
                  </div>
                  <div>
                    奖品类型：{{ item.prize_type }} | 业务类型：{{ item.type }}
                  </div>
                  <div>
                    等级：{{ item.level_name }}
                  </div>
                  <div>
                    单价：¥{{ item.price }}  |
                    回收价：¥{{ item.recovery_price }}
                  </div>
                  <div>数量：{{ item.num }}</div>
                 
                 
                  <div>开出时间：{{ item.created_at }}</div>
                  <div>更新时间：{{ item.updated_at }}</div>
                </div>
              </div>
            </div>

            <el-pagination
              @current-change="getDetailListMobile"
              :current-page="detailParams.page"
              layout="prev, pager, next"
              :total="detailTotal"
              style="margin-top: 10px; text-align: center"
            ></el-pagination>
          </div>
          <div slot="footer">
            <el-button @click="detailVisibleMobile = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "BoxOrderList",
  data() {
    return {
      loading: false,
      detailLoading: false,
      tableData: [],
      pageInfo: { total: 0 },

      // 主订单列表搜索参数
      searchParams: {
        page: 1,
        page_size: 10,
        user_id: "",
      },

      // 订单明细请求参数
      detailParams: {
        page: 1,
        page_size: 10,
        order_id: "",
      },
      detailData: [],
      detailTotal: 0,
      detailVisible: false,
      detailVisibleMobile: false,

      // 表格列配置【新增全部字段】
      columnOptions: [
        { label: "头像", prop: "avatar" },
        { label: "订单ID", prop: "id" },
        { label: "用户ID", prop: "user_id" },
        { label: "用户编号", prop: "user_no" },
        { label: "用户昵称", prop: "nickname" },
        { label: "盲盒图", prop: "box_image" },
        { label: "盲盒ID", prop: "box_id" },
        { label: "盲盒名称", prop: "box_name" },
        { label: "盲盒定价", prop: "box_price" },
        { label: "业务类型", prop: "type" },
        { label: "购买数量", prop: "num" },
        { label: "总支付金额", prop: "total_price" },
        { label: "实付金额", prop: "pay_price" },
        { label: "盲盒钻石支付", prop: "pay_blind_point" },
        { label: "闯关币支付", prop: "pay_challenge_point" },
        { label: "擂台币支付", prop: "pay_fight_point" },
        { label: "PK币支付", prop: "pay_pk_point" },
        { label: "支付时间", prop: "paid_at" },
        { label: "操作", prop: "action" },
      ],
      // 默认全勾选所有列
      checkedColumns: [
        "avatar",
        "id",
        "user_id",
        "user_no",
        "nickname",
        "box_image",
        "box_id",
        "box_name",
        "box_price",
        "type",
        "num",
        "total_price",
        "pay_price",
        "pay_blind_point",
        "pay_challenge_point",
        "pay_fight_point",
        "pay_pk_point",
        "paid_at",
        "action",
      ],

      searchCollapsed: true,
    };
  },
  created() {
    this.getOrderList();
  },
  methods: {
    // 获取订单主列表
    async getOrderList() {
      this.loading = true;
      try {
        const res = await api.loss.boxOrdersIndex({
          params: this.searchParams,
        });
        if (res.data.code == 1000) {
          this.tableData = res.data.data.data || [];
          this.pageInfo.total = res.data.data.total || 0;
        }
      } finally {
        this.loading = false;
      }
    },

    // 获取订单开出明细
    async getDetailList(page = 1) {
      this.detailLoading = true;
      this.detailParams.page = page;
      try {
        const res = await api.loss.boxOrdersBoxOrderDetail({
          params: this.detailParams,
        });
        if (res.data.code == 1000) {
          this.detailData = res.data.data.data || [];
          this.detailTotal = res.data.data.total || 0;
        }
      } finally {
        this.detailLoading = false;
      }
    },

    // PC打开明细弹窗
    openDetailDialog(row) {
      this.detailParams.order_id = row.id;
      this.detailParams.page = 1;
      this.detailVisible = true;
      this.getDetailList();
    },

    // 移动端打开明细弹窗
    openDetailDialogMobile(row) {
      this.detailParams.order_id = row.id;
      this.detailParams.page = 1;
      this.detailVisibleMobile = true;
      this.getDetailList();
    },

    // 移动端明细分页切换
    async getDetailListMobile(page) {
      this.detailParams.page = page;
      this.getDetailList();
    },

    // 重置搜索条件
    resetSearch() {
      this.searchParams = {
        page: 1,
        page_size: 10,
        user_id: "",
      };
      this.getOrderList();
    },

    // 每页条数切换
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getOrderList();
    },
    // 页码切换
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getOrderList();
    },

    // 全选列
    handleCheckAll() {
      this.checkedColumns = this.columnOptions.map((i) => i.prop);
    },
    // 清空列选择
    handleClearAll() {
      this.checkedColumns = [];
    },

    // 折叠/展开搜索栏
    toggleSearch() {
      this.searchCollapsed = !this.searchCollapsed;
    },
    // 行点击空白事件
    handleRowClick() {},
  },
};
</script>

<style scoped>
/* PC样式 */
.order-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

/* 移动端样式 */
.mobile-order-container {
  padding: 12px;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  margin-bottom: 10px;
}
.info .nickname {
  font-size: 16px;
  font-weight: 500;
}
.info .uid {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.7;
  margin-bottom: 10px;
}
.card-footer {
  text-align: right;
}
</style>

<style>
@media (max-width: 768px) {
  .pc-version {
    display: none !important;
  }
  .mobile-version {
    display: block !important;
  }
  .mobile-dialog {
    border-radius: 12px !important;
  }
  .mobile-dialog .el-dialog__body {
    padding: 15px !important;
  }
}
@media (min-width: 769px) {
  .pc-version {
    display: block !important;
  }
  .mobile-version {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/loss/busnissOrder.vue